import { DataObjectFormType } from './types';
import translations from './DataObjectFormTypeBadge.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import styled from 'styled-components';
import {
  colorGreen,
  colorPurple,
  colorRepBg,
  colorRepBorder,
  colorYellow,
} from '@atlas-frontend/design-tokens';

const { addTranslations, useTranslation } = i18nNsFactory(
  'data-object-form-type-badge',
);
addTranslations(translations);

export const DataObjectFormTypeBadge = ({
  formType,
}: {
  formType: DataObjectFormType;
}) => {
  const { t } = useTranslation();
  return (
    <StyledBadge className={formType}>
      {t(`abbreviation.${formType}`)}
    </StyledBadge>
  );
};

const StyledBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 100px;
  border: 1px solid;
  font-weight: 500;

  &:is(.IN) {
    border-color: ${colorGreen[3]};
    background-color: ${colorGreen[2]};
  }
  &:is(.OUTPUT) {
    border-color: ${colorYellow[2]};
    background-color: ${colorYellow[1]};
  }
  &:is(.INTERMEDIATE) {
    border-color: ${colorPurple[4]};
    background-color: ${colorPurple[2]};
    width: 32px;
  }
  &:is(.REPORT) {
    border-color: ${colorRepBorder};
    background-color: ${colorRepBg};
  }
`;
